import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'quarter'
})
export class QuarterPipe implements PipeTransform {
    private min: number = 0;
    private hour = 0;

    transform(value: number): string {
        if (value === 1439) {
            return '23:59';
        } else if (value >= 1425) {
            return '23:45';
        }

        this.min = value % 60;
        this.min = this.min - (this.min % 15);
        this.hour = (value - this.min) / 60;

        return this.double(Math.round(this.hour)) + ':' + this.double(this.min);
    }

    private double(val: number): string | number {
        return val / 10 >= 1 ? val : '0' + val;
    }
}
